/**
 * @description renders the personnel sync history details page
 */

import React from 'react';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Button from '@mui/material/Button';
import { useParams } from 'react-router-dom';

import BodyContainer from '@seccon/shared/ui/components/BodyContainer';
import SyncResults from '@seccon/shared/personnelSyncResults/components/SyncResults';
import { SyncResultsProvider, SyncResultsContext } from '@seccon/shared/personnelSyncResults/contexts/SyncResults';
import NoResults from '@seccon/shared/ui/components/NoResults';
import ErrorBoundary from '@seccon/shared/ui/components/ErrorBoundary';

import useHistoryDetails from './hooks/useHistoryDetails';

const styles = {
  pageHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  }
};

/**
 * Renders the content of the page. It was put in its own component so it can read the sync results
 *  context.
 */
const Content = () => {
  const { historyId } = useParams();

  // Sync results
  const results = React.useContext(SyncResultsContext);

  const isError = useHistoryDetails(historyId);

  // If no results are ready to be display, render a loading overlay
  if (results === null && !isError) {
    return (
      <>
        <Skeleton animation='wave' variant='rectangular' height={40} width='50%' />
        <Skeleton animation='wave' variant='rectangular' height={40} width='50%' />
        <Skeleton animation='wave' variant='rectangular' height={40} width='50%' />
        <Skeleton animation='wave' variant='rectangular' height={40} width='50%' />
      </>
    );
  }

  if (isError) {
    return (
      <NoResults>
        An error occured and personnel sync results could not be loaded.
      </NoResults>
    );
  }

  return (
    <SyncResults />
  );
};

const PersonnelSyncHistoryDetails = () => (
  <BodyContainer>
    <Typography variant='h4' sx={styles.pageHeader}>
      Personnel Sync - Results
      <Button href='..' variant='outlined' sx={styles.actionButton}>
        Back
      </Button>
    </Typography>
    <SyncResultsProvider>
      <ErrorBoundary>
        <Content />
      </ErrorBoundary>
    </SyncResultsProvider>
  </BodyContainer>
);

export default PersonnelSyncHistoryDetails;
